<template>
  <div>
    <div v-if="active == 'N'" class="bg-orange-lightest border-l-4 border-orange text-orange-dark p-4 mb-8 text-lg" role="alert">
      <p v-if="!host.item_auto_reactivate" class="font-bold">Der gewählte Anbieter ist derzeit leider nicht verfügbar 😭</p>
      <p v-if="host.item_auto_reactivate" class="font-bold py-8">Der gewählte Anbieter ist ausgelastet und ab {{ host.item_auto_reactivate }} Uhr wieder verfügbar.</p>
      <p v-if="!host.item_auto_reactivate" class="mt-1">
        Das kann u.a. folgende Gründe haben:
        <ul>
          <li>der Anbieter ist ausgelastet und möchte vorerst keine weiteren Bestellungen entgegennehmen</li>
          <li :class="{ 'font-bold': host.item_auto_inactive == 'Y' }">technische Probleme bei der Annahme der Bestellungen</li>
          <li>vorübergehende Abwesenheit</li>
        </ul>
      </p>
    </div>
    <div v-if="away != false" class="bg-orange-lightest border-l-4 border-orange text-orange-dark p-4 mb-8" role="alert">
      <p v-if="away.title == ''" class="font-bold">Der gewählte Anbieter ist aktuell im Betriebsurlaub ☀️</p>
      <p v-if="away.title != ''" class="font-bold">{{ away.title }}</p>
      <p>
        Ab {{ away.stop }} wieder für dich verfügbar
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActiveHostComponent',
  props: ['active', 'away', 'host']
}
</script>



// WEBPACK FOOTER //
// src/components/ActiveHostComponent.vue